const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill="currentColor" d="M15.427 7.205 1.502.243A1.04 1.04 0 0 0 0 1.17v13.925a1.04 1.04 0 0 0 1.502.928l13.925-6.962a1.038 1.038 0 0 0 0-1.857"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>';
export {
  l as default
};
